import TemplateView from '../../../TemplateView'
import Counter from '../../../components/counterCPT/Counter'
import {HierarchyLevels} from 'constants'
import {customerNameLower, projectNameLower, taskNameLower} from '../../../util/pluralizeUtils'

export default class CounterHeader extends TemplateView {
    constructor({
        changeTab = (tab) => {},
    }) {
        super()

        this.params = {
            changeTab,
        }

        this.state = {
            tab: null,

            counters: {
                customers: 0,
                projects: 0,
                tasks: 0,
            },
        }

        this.onStatePropertyChanged('counters', (counters) => {
            this.customerTab.setState({value: counters.customers})
            this.projectTab.setState({value: counters.projects})
            this.taskTab.setState({value: counters.tasks})

            const allTabsEmpty = this._areAllTabsEmpty()
            this.getEl().toggleClass('disabled', allTabsEmpty)
            this.$customerTab.toggleClass('active', !allTabsEmpty)
            this.$projectTab.toggleClass('active', !allTabsEmpty)
            this.$taskTab.toggleClass('active', !allTabsEmpty)

            this.$customerTabTitle.text(customerNameLower(counters.customers))
            this.$projectTabTitle.text(projectNameLower(counters.projects))
            this.$taskTabTitle.text(taskNameLower(counters.tasks))
        })

        this.onStatePropertyChanged('tab', (tab) => {
            this.$el.toggleClass('selected', tab !== null)

            this.$customerTab.toggleClass('selected', tab === HierarchyLevels.CUSTOMER)
            this.$projectTab.toggleClass('selected', tab === HierarchyLevels.PROJECT)
            this.$taskTab.toggleClass('selected', tab === HierarchyLevels.TASK)
        })
    }

    templateHtml() {
        return '<div class="countersHeaderTabs">' +
               '    <div class="customerTab border">' +
               '        <div class="title hierarchyClass_customer"></div>' +
               '    </div>' +
               '    <div class="projectTab border">' +
               '        <div class="title hierarchyClass_project"></div>' +
               '    </div>' +
               '    <div class="taskTab border">' +
               '        <div class="title hierarchyClass_task "></div>' +
               '    </div>' +
               '</div>'
    }

    afterRender() {
        this.$customerTab = this.find('.customerTab')
        this.$projectTab = this.find('.projectTab')
        this.$taskTab = this.find('.taskTab')
        this.$customerTabTitle = this.find('.customerTab .title')
        this.$projectTabTitle = this.find('.projectTab .title')
        this.$taskTabTitle = this.find('.taskTab .title')

        this.customerTab = new Counter({
            hierarchyLevel: HierarchyLevels.CUSTOMER,
        }).init(this.$customerTab)
        this.customerTab.setState({pale: true})

        this.projectTab = new Counter({
            hierarchyLevel: HierarchyLevels.PROJECT,
        }).init(this.$projectTab)
        this.projectTab.setState({pale: true})

        this.taskTab = new Counter({
            hierarchyLevel: HierarchyLevels.TASK,
        }).init(this.$taskTab)
        this.taskTab.setState({pale: true})

        this.$customerTab.click(() => {
            if (!this._areAllTabsEmpty())
                this.params.changeTab(HierarchyLevels.CUSTOMER)
        })
        this.$projectTab.click(() => {
            if (!this._areAllTabsEmpty())
                this.params.changeTab(HierarchyLevels.PROJECT)
        })
        this.$taskTab.click(() => {
            if (!this._areAllTabsEmpty())
                this.params.changeTab(HierarchyLevels.TASK)
        })

        this.renderInitialState()
    }

    _areAllTabsEmpty() {
        return this.state.counters.tasks === 0 && this.state.counters.projects === 0 && this.state.counters.customers === 0
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/managementAssignmentsPanel/CounterHeader.js